/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileUploadDto } from './FileUploadDto';
import {
    FileUploadDtoFromJSON,
    FileUploadDtoFromJSONTyped,
    FileUploadDtoToJSON,
} from './FileUploadDto';

/**
 * 
 * @export
 * @interface InscriptionFichierUploadDto
 */
export interface InscriptionFichierUploadDto {
    /**
     * 
     * @type {FileUploadDto}
     * @memberof InscriptionFichierUploadDto
     */
    file?: FileUploadDto;
    /**
     * 
     * @type {number}
     * @memberof InscriptionFichierUploadDto
     */
    idinscriptionFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof InscriptionFichierUploadDto
     */
    idinscription?: number;
    /**
     * 
     * @type {number}
     * @memberof InscriptionFichierUploadDto
     */
    idfichier?: number;
    /**
     * 
     * @type {string}
     * @memberof InscriptionFichierUploadDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the InscriptionFichierUploadDto interface.
 */
export function instanceOfInscriptionFichierUploadDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InscriptionFichierUploadDtoFromJSON(json: any): InscriptionFichierUploadDto {
    return InscriptionFichierUploadDtoFromJSONTyped(json, false);
}

export function InscriptionFichierUploadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InscriptionFichierUploadDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : FileUploadDtoFromJSON(json['file']),
        'idinscriptionFichier': !exists(json, 'idinscriptionFichier') ? undefined : json['idinscriptionFichier'],
        'idinscription': !exists(json, 'idinscription') ? undefined : json['idinscription'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function InscriptionFichierUploadDtoToJSON(value?: InscriptionFichierUploadDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': FileUploadDtoToJSON(value.file),
        'idinscriptionFichier': value.idinscriptionFichier,
        'idinscription': value.idinscription,
        'idfichier': value.idfichier,
        'fileName': value.fileName,
    };
}

